(() => {
  const root = document.documentElement;
  const reveal = (node) => node.classList.add('is-visible');
  const all = () => document.querySelectorAll('[data-ww-reveal]:not(.is-visible)');
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduced || !('IntersectionObserver' in window)) {
    root.classList.add('ww-motion-off');
    return;
  }
  // Horizon scrolls inside .page-wrapper, not the window: observe against that box.
  const scroller = document.querySelector('.page-wrapper');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      reveal(entry.target);
      observer.unobserve(entry.target);
    });
  }, { root: scroller && scroller.scrollHeight > scroller.clientHeight ? scroller : null, threshold: 0.08, rootMargin: '0px 0px -4% 0px' });
  const watch = (scope) => scope.querySelectorAll('[data-ww-reveal]:not(.is-visible)').forEach((node) => observer.observe(node));
  watch(document);
  // Fail-open: content must never stay hidden because an observer did not fire.
  window.setTimeout(() => all().forEach(reveal), 2500);
  document.addEventListener('shopify:section:load', (event) => { watch(event.target); window.setTimeout(() => all().forEach(reveal), 1200); });
})();
